module.exports = __webpack_public_path__ + "static/mud_mephit-ee487fbfb4eb05b9e17fb857b4ec83f9.jpg";